import Tickets from '../../../../store/tickets';

angular
    .module('festzelt-os.modules.tickets.main')
    .factory('Tickets', [
        '$injector',
        'Ticket',
        ($injector, Ticket) => new Tickets(Ticket, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/tickets/main/store/tickets.js